module.exports = __webpack_public_path__ + "img/8 Regarder ou lire _.f299df05.png";